import React, { PureComponent } from 'react'
import { createComponent } from '@ycos/fela'
import PropTypes from 'prop-types'

const LayoutContainer = createComponent('LayoutContainer', ({ theme }) => ({
  margin: '0 auto',
  maxWidth: theme.fullBleed ? 'inherit' : theme.breakpoints.xlarge.width
}))

const MarginsContainer = createComponent('MarginsContainer', ({ theme }) => ({
  marginRight: theme.fullBleed ? 0 : theme.breakpoints.xlarge.marginOuter / 2,
  marginLeft: theme.fullBleed ? 0 : theme.breakpoints.xlarge.marginOuter / 2,
  'screen-medium': {
    marginRight: theme.fullBleed ? 0 : theme.breakpoints.xlarge.marginOuter,
    marginLeft: theme.fullBleed ? 0 : theme.breakpoints.xlarge.marginOuter
  },
  maxWidth: theme.fullBleed ? 'inherit' : 'none'
}))

export default class LayoutWithMargins extends PureComponent {
  render() {
    return (
      <LayoutContainer>
        <MarginsContainer>{this.props.children}</MarginsContainer>
      </LayoutContainer>
    )
  }
}

LayoutWithMargins.propTypes = {
  children: PropTypes.node
}
